import { apiClient } from './apiClient';
import { normalizeUsersResponse } from './normalizers';

const base = '/api/auth';

// Service using apiClient
export const authService = {
  login: (email, password, remember) =>
    apiClient
      .post(`${base}/login`, { email, password, remember: !!remember })
      .then(normalizeUsersResponse),
  me: () => apiClient.get(`${base}/me`).then(normalizeUsersResponse),
  refresh: () => apiClient.post(`${base}/refresh`, {}).then(normalizeUsersResponse),
  register: payload => apiClient.post(`${base}/register`, payload).then(normalizeUsersResponse),
  forgotPassword: email => apiClient.post(`${base}/forgot-password`, { email }),
  resendResetLink: email => apiClient.post(`${base}/forgot-password`, { email }),
  resetPassword: (token, password) => apiClient.post(`${base}/reset-password`, { token, password }),
  updateProfile: userData =>
    apiClient.put(`${base}/profile`, userData).then(normalizeUsersResponse),
  logout: () => apiClient.post(`${base}/logout`, {}),
};

export default authService;
